import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject, } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MensagemService } from 'src/app/service/mensagem.service';
import { ICadBase } from '../../model/ICadBase';
import { State } from '../../model/enumState';
import { MatTabChangeEvent } from '@angular/material';
import { Helper } from 'src/app/shared/Helper';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-cad-base',
  templateUrl: './cad-base.component.html',
  styleUrls: ['./cad-base.component.css']
})
export class CadBaseComponent implements OnInit {

  private _estado: State;
  protected _itens: any[];
  private pesquisa = new Subject<string>();

  public filtro: string;
  public Itens: any;
  public itemCorrente: any;
  public loadingVisible: boolean = false;
  public simpleTitle: string;

  public captionEditar: string = "Editar";
  public widthEditar: number = 100;
  public carregando: boolean;


  public get Estado() {
    return this._estado;
  }

  public set Estado(value) {
    this._estado = value;
    if (value != undefined) {
      if (this.cadastro) {
        this.cadastro.EstadoChange(value);
      }
    }
  }

  @Input() cadastro: ICadBase;
  @Input() pesquisaCustomizada;
  @Input() ocultarPesquisa;
  @Input() ocultarBotoes;
  @Input() tamanhoPagina;
  @Input() PodeExcluir = true;
  @Input() Embarcado: boolean = false;
  @Input() complementoTituloPesquisa: string = "";
  @Input() showAuditoria: boolean = true;
  @Input() IdCadastro: string;
  @Input() CustonNomeTitleCancelamento: string;

  @Output() CadastroConcluido: EventEmitter<any> = new EventEmitter<any>();



  constructor(private msg: MensagemService, private router: Router) {
    this.Estado = State.localizando;
    this.carregando = false;
  }

  public GoToHome() {
    this.router.navigate(['/admin']);  
  }

  ngOnInit() {

    if (this.Embarcado) {
      this.widthEditar = 120;
      this.captionEditar = "Selecionar";
    }

    if (!this.tamanhoPagina) {
      this.tamanhoPagina = 10;
    }
    if (this.cadastro) {
      this.simpleTitle = Helper.PrimeiraMinuscula(this.cadastro.title);
    }
    this.refreshData(this);
    this.pesquisa.pipe(
      debounceTime(400))
      .subscribe((value: string) => {
        this.Filtrar();
      });

    if (this.IdCadastro) {
      this.Editar(this.IdCadastro);
    }
  }


  private refreshData(that) {
    if (that.cadastro.service) {
      that.Itens = null;
      that.cadastro.service.GetAll().subscribe(p => {
        that._itens = p;
        that.Itens = that._itens;
      });
    }
  }

  private Filtrar() {
    var that = this;
    function funcFiltro(it): boolean {
      var rt = false;
      if ( 
        ((it.descricao) && (it.descricao.toUpperCase().indexOf(that.filtro.toUpperCase()) >= 0)) ||
        ((it.codigo) && (it.codigo.toUpperCase().indexOf(that.filtro.toUpperCase()) >= 0))
      )
      {
        rt = true;
      }
      return rt;
    };

    var filtrados = new Array();
    if (this.filtro) {

      filtrados = this._itens.filter(funcFiltro)
    }
    else {
      filtrados = this._itens;
    }
    this.Itens = filtrados;
  }

  public pesquisaChange(value: any) {
    this.pesquisa.next(value);
  }

  private retornar(that) {
    that.itemCorrente = null;
    that.Estado = State.localizando;
  }
  private retornarComUpdate(that) {
    that.refreshData(that);
    that.retornar(that);
    that.loadingVisible = false;
  }
  public getId(item): string {
    var nomeProp: string;
    nomeProp = this.cadastro.nome + "Id";
    if (item) {
      return Reflect.get(item, nomeProp);
    }
    else {
      return Reflect.get(this.itemCorrente, nomeProp);
    }
  }

  public Inserir() {
    this.itemCorrente = this.cadastro.NovoItem(null);
    this.Estado = State.inserindo;
  }

  public Editar(id) {
    this.carregando = true;
    this.cadastro.service.GetItem(id).subscribe(rt => {
      this.itemCorrente = this.cadastro.NovoItem(rt);
      this.Estado = State.editando;
      this.carregando = false;
    });
  }

  public Excluir(id) {
    if (id) {
      var that = this;
      this.msg.ConfirmDialog("Exclusão d" + this.cadastro.titleExcluindo, "Realmente deseja excluir " + this.cadastro.titleExcluindo, function (result) {
        if (result) {
          that.carregando = true;
          that.cadastro.service.Excluir(id).subscribe(rt => {
            if (rt.sucesso) {
              that.refreshData(that);
            } else if (rt.fk) {
              that.msg.Error("Não foi possível excluir " + that.cadastro.titleExcluindo + "! Existem outros registros associados.");
            }
            that.carregando = false;

          })
        }
      }
      );
    }
  }
  public Cancelar() {
    var tp = "da edição";
    if (this.Estado == State.inserindo) {
      tp = "da inserção";
    }
    var completo = true;
    if (this.Embarcado) {
      if (this.IdCadastro && this.CustonNomeTitleCancelamento) {
        tp = this.CustonNomeTitleCancelamento;
      }
      else {
        tp = "";
        completo = false;
      }
    }
    var that = this;
    var msgTitle = "Cancelamento";
    if (completo) {
      msgTitle = msgTitle + " " + tp;
      if (!this.Embarcado && !this.CustonNomeTitleCancelamento) {
        msgTitle = msgTitle + " d" + this.cadastro.titleExcluindo;
      }
    }

    var msgQuestion = "Realmente deseja cancelar";
    if (completo) {
      msgQuestion = msgQuestion + " a " + tp;
      if (!this.Embarcado && !this.CustonNomeTitleCancelamento) {
        msgQuestion = msgQuestion + " d" + this.cadastro.titleExcluindo;
      }
    }
    this.msg.ConfirmDialog(msgTitle, msgQuestion, function (result) {
      if (result) {
        if (that.CadastroConcluido) {
          that.CadastroConcluido.emit(null);
        }
        if (!that.IdCadastro) {
          that.retornar(that);
        }
      }
    }
    );
  }

  public Gravar() {
    switch (this.Estado) {
      case State.inserindo:
        this.GravandoNovo();
        break;
      case State.editando:
        this.GravandoEditado();
        break;
    }
  }

  public CancelLoading(that) {
    that.loadingVisible = false;
  }

  private GravandoNovo() {
    if (this.cadastro.validoParaInserir(this.itemCorrente)) {
      this.cadastro.beforeSave(this.itemCorrente, this.Estado);
      if (!this.cadastro.InserindoAssincrono(this.itemCorrente, this, this.Inserindo, this.CancelLoading)) {
        this.Inserindo(this);
      }
      else {
        this.loadingVisible = true;
      }
    }
  }
  protected Inserindo(that) {
    that.loadingVisible = true;
    that.cadastro.service.Inserir(that.itemCorrente).subscribe(rt => {
      if (rt.sucesso) {
        if (that.CadastroConcluido) {
          that.CadastroConcluido.emit(rt.item);
        }
        if (!that.cadastro.afterSave(rt.item, that, that.retornarComUpdate)) {
          if (!that.Embarcado) {
            that.msg.Sucesso(that.cadastro.title + " inserido com sucesso!");
          }
          that.retornarComUpdate(that);
        }
      }
      else {
        that.loadingVisible = false;
      }
    });
  }

  private GravandoEditado() {
    if (this.cadastro.validoParaEditar(this.itemCorrente)) {
      this.cadastro.beforeSave(this.itemCorrente, this.Estado);
      if (!this.cadastro.EditandoAssincrono(this.itemCorrente, this, this.Editando)) {
        this.Editando(this);
      }
    }
  }

  protected Editando(that) {
    that.loadingVisible = true;
    that.cadastro.service.Atualizar(that.itemCorrente).subscribe(rt => {
      if (rt.sucesso) {
        if (that.CadastroConcluido) {
          that.CadastroConcluido.emit(that.itemCorrente);
        }
        if (!that.cadastro.afterSave(that.itemCorrente, that, that.retornarComUpdate)) {
          if (!that.Embarcado) {
            that.msg.Sucesso(that.cadastro.title + " editado com sucesso!");
          }
          that.retornarComUpdate(that);
        }
      }
      else {
        that.loadingVisible = false;
      }
    });
  }
}